import { Typography } from "@mui/material";
import redBoingo from "../assets/images/boingo_logo_red.png";
import { Box } from "@mui/system";
import { Link } from "react-router-dom";

export default function WelcomeFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Box className="welcome-footer" data-test-id="welcome-footer">
        <Box className="footLogo">
          <img src={redBoingo} className="boingo-logo-bottom" alt="logo" />
        </Box>
        <Box className="footContent1">
          <Box className="footSupport">
            <Link to="/faqs" data-test-id="welcome-faqs-link">Boingo customer support</Link> is available
            24/7/365.
          </Box>
          <Box className="footLinks" data-test-id="welcome-footer-links">
            <a
              target="_blank"
              href="https://www.boingo.com/legal/boingo-privacy-policy/"
              data-test-id="welcome-privacy-link"
            >
              Privacy policy
            </a>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <a
              target="_blank"
              href="https://www.boingo.com/legal/website-terms-use-acceptable-use-policy/"
              data-test-id="welcome-terms-link"
            >
              Terms of use
            </a>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <a
              target="_blank"
              href="https://www.boingo.com/legal/cookie-policy/"
              data-test-id="welcome-cookie-link"
            >
              Cookie policy
            </a>
          </Box>
          <Box className="footCopyright" data-test-id="copyright-link">
            &copy; {currentYear} Boingo Wireless, Inc. All rights reserved.
          </Box>
          <Box className="dmca" data-test-id="dmca">
            <Typography>Movies, television shows, music, video games, and other types of similar content are protected by copyright, and downloading or sharing these materials without permission (for instance from a pirate site or a peer-to-peer sharing site) violates federal law.  Please only access these types of entertainment from appropriate websites.  Violation of federal copyright protection laws may result in substantial civil and financial penalties, including a fine for each downloaded file, criminal penalties up to $250,000 and five years in prison, and discipline under the Uniform Code of Military Justice.</Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
}
